import game from './game'
import rtc from './rtc'

export default { game, rtc }
